import { Inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PricingTableDialogService } from './pricing-table-dialog.service';
import { WINDOW } from 'src/app/shared/injection-tokens/window.injection-token';
import {
  PricingTableDialogEffectActions,
  PricingTableDialogActions,
} from './pricing-table-dialog.actions';
import { catchError, map, switchMap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { of } from 'rxjs';

@Injectable()
export class PricingTableDialogEffects {
  public pageLoaded$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PricingTableDialogActions.opened),
      switchMap(() =>
        this.pricingTableDialogService.generatePricingTableSessionClientSecret().pipe(
          map((pricingTableSession) =>
            PricingTableDialogEffectActions.loadPricingTableSucceeded({
              pricingTableSession,
            }),
          ),
          catchError(({ error: responseBody }: HttpErrorResponse) =>
            of(
              PricingTableDialogEffectActions.loadPricingTableErrored({
                error: responseBody.error,
              }),
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    @Inject(WINDOW) private window: Window,
    private actions$: Actions,
    private pricingTableDialogService: PricingTableDialogService,
  ) {}
}
